import React from 'react';
import { Box, Icon, IconButton } from '@nextiva/next-ui-components';
import { OverlineTypo } from '../WizardV3.styled';

export function LabelWithDeleteButton({
  dataTestId,
  label = 'Delete Sample Message',
  onDelete,
  sampleMessageId,
}: {
  dataTestId: string;
  label: string;
  sampleMessageId: string;
  onDelete: () => void;
}) {
  return (
    <Box
      display="flex"
      sx={{ justifyContent: 'space-between', alignItems: 'flex-end' }}
    >
      <OverlineTypo>{label}</OverlineTypo>
      <IconButton
        aria-label="delete-icon"
        data-testid={`${dataTestId}-${sampleMessageId}-IconButton`}
        onClick={onDelete}
      >
        <Icon icon="delete" color="error" />
      </IconButton>
    </Box>
  );
}
